"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAYMENT_TYPES = void 0;
exports.PAYMENT_TYPES = [{
  type: "Checking",
  code: "1",
  biztalkCode: "EC",
  description: "eCheck",
  isCreditCard: false,
  isBankAccount: true,
  paymentMethodCode: "EC"
}, {
  type: "Savings",
  code: "2",
  biztalkCode: "EC",
  description: "eCheck",
  isCreditCard: false,
  isBankAccount: true,
  paymentMethodCode: "EC"
}, {
  type: "Corporate",
  code: "3",
  biztalkCode: "EC",
  description: "eCheck",
  isCreditCard: false,
  isBankAccount: true,
  paymentMethodCode: "EC"
}, {
  type: "CorporateSavings",
  code: "4",
  biztalkCode: "EC",
  description: "eCheck",
  isCreditCard: false,
  isBankAccount: true,
  paymentMethodCode: "EC"
}, {
  type: "AmericanExpress",
  code: "AX",
  biztalkCode: "AX",
  description: "Credit Card",
  isCreditCard: true,
  isBankAccount: false,
  paymentMethodCode: "CC"
}, {
  type: "Discover",
  code: "DI",
  biztalkCode: "DI",
  description: "Credit Card",
  isCreditCard: true,
  isBankAccount: false,
  paymentMethodCode: "CC"
}, {
  type: "MasterCard",
  code: "MC",
  biztalkCode: "MC",
  description: "Credit Card",
  isCreditCard: true,
  isBankAccount: false,
  paymentMethodCode: "CC"
}, {
  type: "Visa",
  code: "VI",
  biztalkCode: "VI",
  description: "Credit Card",
  isCreditCard: true,
  isBankAccount: false,
  paymentMethodCode: "CC"
}, {
  type: "PaymentTerms",
  code: "PT",
  biztalkCode: "",
  description: "Payment Terms",
  isCreditCard: false,
  isBankAccount: false,
  paymentMethodCode: "PT"
}, {
  type: "Paypal",
  code: "PP",
  biztalkCode: "PP",
  description: "Paypal",
  isCreditCard: false,
  isBankAccount: false,
  paymentMethodCode: "PP"
}];